<div [ngStyle]="{ color: text_color }">
  <div class="container">

    <div class="row d-flex justify-content-center desktop mt-3" [ngClass]="{'desktop': component.primary.mobile_carousel_mode == 'enabled'}">
      @for (item of component.fields; track item) {
        <div class="text-center icon-group col-12" [ngClass]="{'col-lg-3 col-md-4': component.fields.length > 5, 'col-md': component.fields.length < 6}">
          @if (item.icon) {
            <img class="hiw-img pl-3 pr-3 pb-2" style="max-width:90px" [alt]="item.icon?.alt" [src]="item.icon?.url" />
          }
          <p tabindex="0" role="text" class="cap-head"><strong [innerHTML]="(getHtml(item.caption, vehicleObject) || '') | safeHtml"></strong></p>
          @if (item.disclaimer_subscript) {
            <div class="disclaimer_subscript" (click)="showNotification(item.disclaimer_text)">
              {{item.disclaimer_subscript[0].text}}
            </div>
          }
        </div>
      }
    </div>

    <div class="mt-3" [ngClass]="{'d-none': component.primary.mobile_carousel_mode !== 'enabled', 'mobile': component.primary.mobile_carousel_mode == 'enabled'}">
      <ngx-slick-carousel class="carousel" [config]="slideConfig" #slickModal="slick-carousel">
        @for (item of component.fields; track item) {
          <div ngxSlickItem class="slide">
            <div class="w-100 p-2">
              <img class="hiw-img pl-3 pr-3 pb-2" style="max-width:90px" [alt]="item.icon?.alt" [src]="item.icon?.url" />
              <p tabindex="0" class="cap-head"><strong [innerHTML]="(getHtml(item.caption, vehicleObject) || '') | safeHtml"></strong></p>
            </div>
          </div>
        }
      </ngx-slick-carousel>
    </div>

  </div>
</div>
